window.enquiryButtonClickHandler = function(
  onError,
  checkoutUrl,
  optionalUrl,
  isPricingComponentEnabled = false,
  cmsCarConfigurationUrl,
  sessionId = null,
) {
  var serverUrl = process.env.GRAPHQL_SERVER_URL;
  var carConfigurationUrl = window.location.href;
  var isinIframe = window !== top;
  var hasSession = sessionId !== null && isinIframe;

  if (cmsCarConfigurationUrl) {
    carConfigurationUrl = cmsCarConfigurationUrl;
  }

  if (optionalUrl) {
    carConfigurationUrl = optionalUrl;
  }

  var xhr = new XMLHttpRequest();
  xhr.responseType = "json";
  xhr.open("POST", serverUrl, true);
  xhr.setRequestHeader("Content-Type", "application/json");
  xhr.setRequestHeader("X-Brand", process.env.REACT_APP_BRAND_CODE);
  xhr.setRequestHeader("X-Language", process.env.REACT_DEFAULT_LANGUAGE);
  xhr.setRequestHeader("X-Region", process.env.REACT_APP_REGION);
  xhr.setRequestHeader("X-Country", process.env.REACT_APP_COUNTRY);
  hasSession && xhr.setRequestHeader("X-SE-Session", sessionId);

  xhr.onerror = onError;
  xhr.onload = function() {
    try {
      if (isPricingComponentEnabled) {
        var url = `${checkoutUrl}?token=${xhr.response.data.createHeadlessDeal.uuid}`;
        window.open(url, "_self");
      } else {
        window.open(xhr.response.data.createJLRDeal + (hasSession ? "&newBasket=true" : ""), "_self");
      }
    } catch (e) {
      onError(e);
    }
  };

  var financeFormInput = localStorage.getItem(
    `${process.env.REACT_APP_COUNTRY}_${process.env.REACT_APP_BRAND_CODE}_finance_form_input`
  );

  var variables = {
    carConfigurationUrl,
    checkoutUrl,
    financeFormInput: financeFormInput ? JSON.parse(financeFormInput) : null,
  };

  // @Todo clean up this file once the Pricing Component is done
  // on development and use only the createHeadlessDeal for JLR Markets
  if (isPricingComponentEnabled) {
    xhr.send(
      JSON.stringify({
        query: `mutation createHeadlessDeal($carConfigurationUrl: String!, $checkoutUrl: String, $financeFormInput: FinanceFormInput){
          createHeadlessDeal(
            carConfigurationUrl: $carConfigurationUrl,
            checkoutUrl: $checkoutUrl,
            financeFormInput: $financeFormInput
          ){
            uuid
          }
        }`,
        variables,
      })
    );
  } else {
    xhr.send(
      JSON.stringify({
        query: `mutation CreateJLRDeal($carConfigurationUrl: String!, $checkoutUrl: String, $financeFormInput: FinanceFormInput){
          createJLRDeal(
            carConfigurationUrl: $carConfigurationUrl,
            checkoutUrl: $checkoutUrl,
            financeFormInput: $financeFormInput
          )
        }`,
        variables,
      })
    );
  }
};

window.iprEnquiryButtonHandler = function (optionalUrl, checkoutUrl, onError) {
  var onErrorFunction = onError ? onError : (e) => console.log(e);
  window.enquiryButtonClickHandler(onErrorFunction, null, optionalUrl);
};
